var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageLevel2Empty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 210,
    viewBox: "0 0 501 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3362_11355)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.278809,
    width: 500,
    height: 210,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.278809 36.9297H500.279V210H0.278809V36.9297Z",
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0554,
    y: 109.648,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0554,
    y: 142.055,
    width: 55.9161,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0554,
    y: 164.461,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0554,
    y: 185,
    width: 70.4691,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.127,
    y: 109.648,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.199,
    y: 109.648,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.271,
    y: 109.648,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0554,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.097,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.138,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.179,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.687 50.0484L476.503 53.2334L473.317 50.0474C473.222 49.9543 473.094 49.9024 472.96 49.9029C472.827 49.9035 472.699 49.9565 472.605 50.0504L471.905 50.7514C471.857 50.7974 471.819 50.8525 471.793 50.9135C471.766 50.9745 471.753 51.0402 471.752 51.1066C471.752 51.173 471.765 51.2388 471.79 51.3001C471.816 51.3614 471.854 51.4169 471.901 51.4634L475.086 54.6474L471.902 57.8334C471.809 57.9288 471.757 58.057 471.758 58.1903C471.759 58.3235 471.812 58.4511 471.906 58.5454L472.606 59.2454C472.812 59.4524 473.122 59.4454 473.318 59.2494L476.504 56.0644L479.688 59.2494C479.783 59.3425 479.912 59.3942 480.045 59.3935C480.178 59.3927 480.306 59.3395 480.4 59.2454L481.101 58.5454C481.149 58.4994 481.187 58.4442 481.213 58.3832C481.239 58.3221 481.253 58.2565 481.253 58.1901C481.253 58.1237 481.24 58.0579 481.215 57.9966C481.189 57.9354 481.151 57.8799 481.104 57.8334L477.918 54.6474L481.104 51.4634C481.197 51.3682 481.249 51.2401 481.248 51.1068C481.248 50.9736 481.195 50.8459 481.101 50.7514L480.401 50.0514C480.354 50.0034 480.298 49.9652 480.236 49.9389C480.174 49.9126 480.108 49.8989 480.041 49.8984C479.975 49.899 479.91 49.9125 479.85 49.9382C479.789 49.964 479.734 50.0014 479.688 50.0484H479.687Z",
    fill: "#9FADBC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.278809,
    y1: 36.2422,
    x2: 500.279,
    y2: 36.2422,
    stroke: "#9FADBC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0554,
    y: 47.8984,
    width: 80,
    height: 50,
    rx: 5,
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4105 63.1562C51.4105 67.0696 48.2381 70.2421 44.3247 70.2421C40.4112 70.2421 37.2388 67.0696 37.2388 63.1562C37.2388 59.2428 40.4112 56.0703 44.3247 56.0703C48.2381 56.0703 51.4105 59.2428 51.4105 63.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1467 73.1771C63.4626 72.5255 62.3875 72.5255 61.7033 73.1771L50.0587 84.2672L46.5023 80.4765C45.8025 79.7306 44.6183 79.7306 43.9185 80.4765L38.0376 86.7448C36.9763 87.876 37.7784 89.7283 39.3295 89.7283H77.0968C78.6959 89.7283 79.4765 87.7769 78.3185 86.674L64.1467 73.1771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.127,
    y: 47.8984,
    width: 80,
    height: 50,
    rx: 5,
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.482 63.1562C146.482 67.0696 143.31 70.2421 139.396 70.2421C135.483 70.2421 132.311 67.0696 132.311 63.1562C132.311 59.2428 135.483 56.0703 139.396 56.0703C143.31 56.0703 146.482 59.2428 146.482 63.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.218 73.1771C158.534 72.5255 157.459 72.5255 156.775 73.1771L145.131 84.2672L141.574 80.4765C140.874 79.7306 139.69 79.7306 138.99 80.4765L133.109 86.7448C132.048 87.876 132.85 89.7283 134.401 89.7283H172.169C173.768 89.7283 174.548 87.7769 173.39 86.674L159.218 73.1771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.199,
    y: 47.8984,
    width: 80,
    height: 50,
    rx: 5,
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.554 63.1562C241.554 67.0696 238.382 70.2421 234.468 70.2421C230.555 70.2421 227.383 67.0696 227.383 63.1562C227.383 59.2428 230.555 56.0703 234.468 56.0703C238.382 56.0703 241.554 59.2428 241.554 63.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.291 73.1771C253.606 72.5255 252.531 72.5255 251.847 73.1771L240.203 84.2672L236.646 80.4765C235.946 79.7306 234.762 79.7306 234.062 80.4765L228.181 86.7448C227.12 87.876 227.922 89.7283 229.473 89.7283H267.241C268.84 89.7283 269.62 87.7769 268.462 86.674L254.291 73.1771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.271,
    y: 47.8984,
    width: 80,
    height: 50,
    rx: 5,
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.626 63.1562C336.626 67.0696 333.454 70.2421 329.541 70.2421C325.627 70.2421 322.455 67.0696 322.455 63.1562C322.455 59.2428 325.627 56.0703 329.541 56.0703C333.454 56.0703 336.626 59.2428 336.626 63.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.363 73.1771C348.679 72.5255 347.603 72.5255 346.919 73.1771L335.275 84.2672L331.718 80.4765C331.018 79.7306 329.834 79.7306 329.134 80.4765L323.254 86.7448C322.192 87.876 322.994 89.7283 324.545 89.7283H362.313C363.912 89.7283 364.692 87.7769 363.534 86.674L349.363 73.1771Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.27881,
    y: 1,
    width: 498,
    height: 208,
    rx: 9,
    stroke: "#9FADBC",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3362_11355"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.278809,
    width: 500,
    height: 210,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLevel2Empty);
export default __webpack_public_path__ + "static/media/Image-level2-empty.db96aa69d55b457efc1c3d1d18339bed.svg";
export { ForwardRef as ReactComponent };